import React from "react";
import Navbar from "./component/Navbar";
import Meme from "./component/Meme";

function App(){
  return (
    <div className="container">
      <Navbar />
      <Meme />
    </div>
  )
}

export default App;
